module.exports = __webpack_public_path__ + "img/flame.ffae159a.png";